module.exports = __webpack_public_path__ + "img/title4.425b5184.svg";